const imageRequestCache = new Map()

export const fetchAndCacheImage = (url) => {
  if (!url) return Promise.resolve('')

  // Check if the image is already in the memory cache
  if (imageRequestCache.has(url)) {
    return Promise.resolve(imageRequestCache.get(url))
  }

  // Create a new image element
  const img = new Image()

  // Use a promise to handle loading or error
  const imagePromise = new Promise((resolve, reject) => {
    img.onload = () => {
      // Cache the image data in memory once it is loaded
      imageRequestCache.set(url, img.src)
      resolve(img.src) // Resolve the promise with the image src
    }

    img.onerror = (err) => {
      console.error('Error loading image:', err)
      console.error('Failed image URL:', img.src)
      imageRequestCache.delete(url) // Clean up cache if it fails
      reject(err) // Handle error
    }

    // Start loading the image
    img.src = url
  })

  // Cache the in-progress promise
  imageRequestCache.set(url, imagePromise)

  return imagePromise
}

// Function to retrieve the image or fetch if necessary
export const getImage = (url) => {
  if (!url) return ''

  // Check if the image is already cached in memory
  if (imageRequestCache.has(url)) {
    const cachedImage = imageRequestCache.get(url)
    return cachedImage
  }

  // Fetch and cache the image if not found in cache
  fetchAndCacheImage(url)

  return url // Return the original URL as fallback for first-time load
}
